import React, { useCallback } from "react";
import * as Scrivito from "scrivito";
import { Col } from "reactstrap";
import { useTranslate } from "hooks";
import { useWizardData } from "hooks/wizardHooks";
import { WizardSingleQuestionnaireControls } from "./WizardQuestionnaire/WizardSingleQuestionnaireControls";
import { useSubType, useWizardActions } from "../../../../stores/wizardStore";

export const WizardIntro = Scrivito.connect(() => {
  const translate = useTranslate();
  const subType = useSubType();

  const { wizardSubTypeObj } = useWizardData(subType);

  const { changeWizardStep } = useWizardActions();

  const handleClickContinue = useCallback(async () => {
    changeWizardStep({});
  }, [changeWizardStep]);

  return (
    <div className="pt-4 pb-5_5">
      <div className="d-flex justify-content-between align-items-center font">
        <h3 className="mb-1">{translate(`WIZARD_INTRO_TITLE_${subType}`)}</h3>
      </div>
      <h4 className="mb-2">{translate(`WIZARD_INTRO_SUBTITLE_${subType}`)}</h4>
      <WizardSingleQuestionnaireControls
        className="mb-3"
        handleClickContinue={handleClickContinue}
      />
      <Col md="8" xl="12" sm="12" className="pb-5_5">
        <div className="text-gray-700 fs-md">
          {translate(`WIZARD_INTRO_TEXT_${subType}`)}
        </div>
      </Col>
      <Scrivito.ContentTag content={wizardSubTypeObj} attribute="introMedia" />
    </div>
  );
});
